if(!customElements.get('noor-photo-gallery')){
 customElements.define('noor-photo-gallery',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   this.frames=[...this.querySelectorAll('[data-photo-frame]')];this.thumbs=[...this.querySelectorAll('[data-photo-index]')];this.index=0;this.hasShown=false;
   this.dialog=this.querySelector('dialog');this.classList.add('is-ready');
   this.addEventListener('click',e=>{
    const thumb=e.target.closest('[data-photo-index]');if(thumb){this.show(Number(thumb.dataset.photoIndex));return;}
    const step=e.target.closest('[data-photo-step]');if(step){this.show(this.index+Number(step.dataset.photoStep));return;}
    const zoom=e.target.closest('[data-photo-zoom]');if(zoom){e.preventDefault();this.lastFocus=zoom;const source=zoom.querySelector('img'),large=this.querySelector('[data-photo-large]');large.src=source.dataset.fullSrc;large.alt=source.alt;this.dialog.showModal();return;}
    if(e.target.closest('[data-photo-close]'))this.dialog.close();
   },{signal});
   this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},{signal});
   this.dialog.addEventListener('close',()=>this.lastFocus?.focus({preventScroll:true}),{signal});
   const thumbs=this.querySelector('.npg-thumbnails');
   thumbs.addEventListener('keydown',e=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
    e.preventDefault();const rtl=getComputedStyle(this).direction==='rtl';
    const next=e.key==='Home'?0:e.key==='End'?this.frames.length-1:this.index+((e.key==='ArrowRight')!==rtl?1:-1);
    this.show(next);this.thumbs[this.index].focus({preventScroll:true});
   },{signal});
   let start;
   const stage=this.querySelector('.npg-stage');
   stage.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{signal,passive:true});
   stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+((dx<0)!==(getComputedStyle(this).direction==='rtl')?1:-1));},{signal,passive:true});
   this.show(0);
  }
  show(value){
   this.index=Math.max(0,Math.min(this.frames.length-1,value));
   this.frames.forEach((f,i)=>f.hidden=i!==this.index);
   const img=this.frames[this.index].querySelector('img');img.loading='eager';
   this.thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
   this.querySelector('[data-photo-position]').textContent=this.index+1;
   this.querySelector('[data-photo-step="-1"]').disabled=this.index===0;
   this.querySelector('[data-photo-step="1"]').disabled=this.index===this.frames.length-1;
   if(this.hasShown)this.thumbs[this.index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});this.hasShown=true;
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
 });
}

